export default "__VITE_ASSET__0a5bde94__"